module.exports = __webpack_public_path__ + "img/phone.a874fb28.svg";